
export async function verifyToken (token) {
  try {
    const response = await fetch(`api/auth/verify-token?token=${token}`, {
      method: 'GET',
      credentials: 'include',
    });

    if (response.ok) {
      // Assuming the API returns a JSON object 
      // {"message": "Token verified"}
      const data = await response.json();
      console.log('Token verification successful:', data);
      // const tokenData = parseJwt(token);
      // clientId = tokenData.client_id; // Get client ID from token
      return true;
    } else {
      console.error('Token verification failed:', await response.text());
      return false;
    }
  } catch (err) {
    console.error('Error verifying token:', err);
    return false;
  }
}

export async function login() {
  const code = document.getElementById('client_code').value.trim();
  const nick = document.getElementById('nick').value.trim();

  if (!code || !nick) {
    alert('Please enter both code and nickname.');
    return false;
  }

  try {
    const response = await fetch('/api/auth/login', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ nick: nick, code: code })  // Ensure correct keys
    });

    if (response.ok) {
      // Assuming the API returns a JSON object with a token
      // {"access_token": access_token}
      const data = await response.json();
      console.log('[Login] Login successful:', data);     
      return {success: true, token: data.access_token}; // Return the access token
    } else {
      const error = await response.text();
      alert('Login failed: ' + error);
      return false;
    }
  } catch (err) {
    console.error('Login error:', err);
    alert('Network error. Please try again.');
    return false;
  }
}

export async function registerClient() {
  const firstName = document.getElementById('first_name')?.value.trim();
  const lastName = document.getElementById('last_name')?.value.trim();
  const email = document.getElementById('email')?.value.trim();
  const nicksInput = document.getElementById('nicks')?.value.trim();

  if (!firstName || !lastName || !email) {
    alert('Please fill out all fields');
    return false;
  }

  // Split nicks by comma and trim whitespace
  let nicks = nicksInput ? nicksInput.split(",").map(n => n.trim()) : [];
  // Use first name as default if niks are not provided
  if (nicks.length === 0) {
    nicks = [firstName]; 
  }

  // Validate email format
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailPattern.test(email)) {
    alert("Please enter a valid email address!");
    return;
  }

  try {
    const response = await fetch('/api/clients', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ 
        first_name: firstName,
        last_name: lastName,
        email: email,
        nicks: nicks })
    });

    if (!response.ok) {
      const error = await response.text();
      alert(`Registration failed: ${error}`);
      return false;
    }

    console.log('✅ Registration successful');
    return true;

  } catch (err) {
    console.error('Registration error:', err);
    alert('Something went wrong. Please try again.');
    return false;
  }
}

// Helpers
const parseJwt = (token) => {
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    return JSON.parse(window.atob(base64));
  } catch (e) {
    console.error('Invalid JWT token:', e);
    return null;
  }
}
